import { Typography } from "@vapor/react-extended";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Stack } from "@vapor/react-material";

const TrashBinHeader = ({ documentListLength }) => {
  return (
    <div>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
      >
        <Typography
          sx={{
            fontFamily: "Cairo",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "28px",
            color: "#004E75",
            paddingBottom: "10px",
          }}
        >
          Cestino
        </Typography>
        {documentListLength > 0 && (
          <Button
            onClick={() => {
              console.log("Svuota cestino");
            }}
            startIcon={<FontAwesomeIcon fontSize={"14px"} icon={faTrash} />}
          >
            Svuota cestino
          </Button>
        )}
      </Stack>
      {documentListLength > 0 && (
        <Typography
          sx={{
            fontFamily: "Roboto",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "20px",
            color: "#1F292E",
          }}
        >
          I documenti nel cestino verranno eliminati definitivamente dopo 30
          giorni.
        </Typography>
      )}
    </div>
  );
};

export default TrashBinHeader;
